<template>
  <div :class="_containerCss">
    <div :class="_stepsCss">
      <div class="side-content">
        <div id="sticky-wrapper" class="sticky-wrapper">
          <div :id="id + '_sticky'" class="sticky">
            <ul
              :class="_wizardCss"
              role="tablist"
              :aria-label="
                caption
                  ? caption
                  : resolveTxt('skin.stepper.caption', 'Details')
              "
              :aria-orientation="orientation"
            >
              <!-- TODO: Readonly  -->
              <li
                v-for="(item, idx) in items"
                :key="idx"
                :class="{
                  active: item.step == sel
                }"
                role="presentation"
              >
                <a
                  :ref="'tab' + item.step"
                  class="tab-focus"
                  :class="{ 'align-right': simple }"
                  href="#"
                  :data-button="item.title"
                  :data-label="item.title"
                  :aria-selected="item.step === sel ? 'true' : 'false'"
                  :aria-controls="id ? id + '_tab_panel' : null"
                  :tabindex="item.step === sel ? '0' : '-1'"
                  role="tab"
                  @click.prevent="_onClick($event, item.step)"
                  @keydown.space.prevent="_onClick($event, item.step)"
                  @keydown.up.prevent="previousTab($event, item.step)"
                  @keydown.down.prevent="nextTab($event, item.step)"
                  @keydown.left.prevent="previousTab($event, item.step)"
                  @keydown.right.prevent="nextTab($event, item.step)"
                  @keydown.tab="focusTabPanel($event, $el, $refs.tabpanel)"
                >
                  <cat-icon
                    v-if="stepsOnRight && detailedItems[idx].icon"
                    :class="detailedItems[idx].style"
                    :decorative="false"
                    :icon="detailedItems[idx].icon"
                    :icon-label="detailedItems[idx].statusCaption"
                  >
                  </cat-icon
                  >{{ item.title
                  }}<cat-icon
                    v-if="!stepsOnRight && detailedItems[idx].icon"
                    :class="detailedItems[idx].style"
                    :decorative="false"
                    :icon="detailedItems[idx].icon"
                    :icon-label="detailedItems[idx].statusCaption"
                  >
                  </cat-icon
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div :class="_contentCss">
      <div
        :id="id ? id + '_tab_panel' : null"
        ref="tabpanel"
        class="main-content"
        :class="tabPanelClass"
        tabindex="0"
        role="tabpanel"
        :aria-label="items[sel - 1].title"
        @keydown.tab="focusoutTabPanel($event, $el, $refs.tabpanel)"
        @click="focusoutTabPanel($event, $el, $refs.tabpanel)"
      >
        <a name="main-content"></a>
        <slot></slot>
        <slot name="buttonpad"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import TabsMixin from "../utilities/tabsMixin";
import CatIcon from "@/components/utilities/catIcon.vue";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const addContentClass = inject("addContentClass", null);

    return {
      resolveTxt,
      addContentClass
    };
  },
  name: "CatReadOnlyStepper",
  components: { CatIcon },
  mixins: [TabsMixin],
  props: {
    id: {
      type: [String, Number],
      description: "Sets the ID attributes of child elements."
    },
    stepsOnRight: {
      type: Boolean,
      default: true,
      description:
        "Sets whether the tabs appear on the left or right side of their content."
    },
    items: {
      type: [Array]
    },
    selected: [Number],
    stepAlertDisplayLevel: {
      type: [String, Number],
      default: 1,
      description:
        "This will indicate the types of alert icon available to show up in the stepper links. Depending on the status of the form section, different icon will show."
    },
    simple: [Boolean],
    alternate: {
      type: Boolean,
      default: false,
      description:
        "Used in conjunction with simple for an alternate style. White background with CSS shadows."
    },
    tabPanelClass: String,
    caption: {
      type: String,
      description: "Accessible name to identify the steps group."
    }
  },
  data: function () {
    return {
      sel: this.selected ? this.selected : 1,
      responsiveShow: true,
      orientation: "vertical"
    };
  },
  computed: {
    numCompleted: function () {
      return this.items.reduce(
        (acc, cur, idx) => acc + (cur.complete ? 1 : 0),
        0
      );
    },
    _stepsCss: function () {
      return {
        // "small-12": true,
        // "mlarge-4": !this.simple,
        // "mlarge-3": this.simple,
        // "mlarge-push-8": this.stepsOnRight && !this.simple,
        // "mlarge-push-9": this.stepsOnRight && this.simple,
        // cell: true,
        "stepper-nav": true,
        hidden: this.items.length < 2
      };
    },
    _contentCss: function () {
      return {
        // "small-12": true,
        // "mlarge-8": !this.simple,
        // "mlarge-9 stepper-content": this.simple && this.items.length > 1,
        "stepper-content": true,
        // "mlarge-12": this.simple && this.items.length < 2,
        // "mlarge-pull-4": this.stepsOnRight && !this.simple,
        // "mlarge-pull-3":
        //   this.stepsOnRight && this.simple && this.items.length > 1,
        // cell: true
        alternate: this.alternate
      };
    },

    _wizardCss: function () {
      return {
        wizard: true,
        // mtt: true,
        simple: this.simple,
        alternate: this.alternate,
        // "text-align-right": this.simple && !this.stepsOnRight,
        // "text-align-left": this.simple && this.stepsOnRight,
        visible: this.responsiveShow,
        "steps-on-right": this.stepsOnRight
      };
    },

    _containerCss: function () {
      return {
        "cat-stepper readonly": true,
        // "grid-x": true,
        // ptt: true,
        // "grid-margin-x": this.simple,
        simple: this.simple,
        "steps-on-right": this.stepsOnRight,
        alternate: this.alternate,
        "only-one-child": this.simple && this.items.length < 2
      };
    },
    /**
     * The items prop containing additional details ie. styling, icon, accessible names
     * @returns {unknown[]}
     */
    detailedItems: function () {
      var t = this;
      return this.items.map(function (item) {
        var detail = t.itemDetails(item);
        return {
          step: item.step,
          icon: detail.icon,
          statusCaption: detail.statusCaption,
          style: detail.style
        };
      });
    }
  },
  watch: {
    selected: function (newsel) {
      this.sel = newsel;
    }
  },
  created: function () {
    this._default = this.selected ? this.selected : this.items[0].step;
  },

  mounted: function () {
    if (this.addContentClass) {
      // this.addContentClass('has-side-content');
    }
    // jQuery('#' + this.id + '_sticky').sticky({
    //   topSpacing: 100,
    //   bottomSpacing: 100,
    // });
  },

  methods: {
    _onClick: function (event, step) {
      this.sel = step;
      this.$emit("ui-click", {
        event: event,
        value: step,
        id: this.id ? this.id : null
      });
    },
    nextTab: function (event, step) {
      const index = step === this.items.length ? 1 : step + 1;
      this.focusTab(index);
    },
    previousTab: function (event, step) {
      const index = step === 1 ? this.items.length : step - 1;
      this.focusTab(index);
    },
    focusTab: function (index) {
      jQuery(this.$refs["tab" + index], this.$el)
        .first()
        .focus();
    },
    getColor: function (item) {
      return item.complete ? "primary" : "transparent";
    },
    _getRules: function (item) {
      // console.log("items", !item.errors.length > 0);
      return [() => !item.errors.length > 0];
    },
    /**
     * Returns the additional details on the item
     * Readonly stepper are not sequential so we don't need to show current and complete steps
     * - icon
     * - statusCaption
     * - style
     */
    itemDetails: function (item) {
      var detail = {};
      if (item.editable && item.invalid) {
        detail = {
          statusCaption: this.resolveTxt(
            "skin.stepper.step.incomplete",
            "Incomplete"
          ),
          icon: "attention",
          style: "incomplete"
        };
      } else if (
        item.editable &&
        item.warning &&
        this.stepAlertDisplayLevel >= 2
      ) {
        detail = {
          statusCaption: this.resolveTxt(
            "skin.stepper.step.warning",
            "Warning"
          ),
          icon: "attention-circled",
          style: "warning"
        };
      } else if (
        item.editable &&
        item.infomessage &&
        this.stepAlertDisplayLevel >= 3
      ) {
        detail = {
          statusCaption: this.resolveTxt(
            "skin.stepper.step.info",
            "Has information"
          ),
          icon: "info-circled",
          style: "infomessage"
        };
      } else if (item.debugmessage && this.stepAlertDisplayLevel >= 4) {
        detail = {
          statusCaption: this.resolveTxt(
            "skin.stepper.step.debug",
            "Has debug information"
          ),
          icon: "edit",
          style: "debugmessage"
        };
      }
      return detail;
    }
  }
  //extends : VMenu,
});
</script>
